import defaultFetch from 'isomorphic-unfetch'
import { MarketingPreferencesData } from '../domain/types'
import { MarketingPreferencesAPIResponse } from './types'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
}

export function createMarketingPreferencesApiClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = { NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL },
    fetch = defaultFetch,
  } = dependencies as Dependencies

  async function updateMarketingPreferences(payload: MarketingPreferencesData): Promise<MarketingPreferencesAPIResponse> {
    const response = await fetch(`${env.NEXT_PUBLIC_API_BASE_URL}/CustomerOptOutForm/PostOptOut`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    if (!response.ok) {
      throw new Error('Error updating profile')
    }
    return await response.json() as MarketingPreferencesAPIResponse
  }

  return {
    updateMarketingPreferences,
  }
}

export default createMarketingPreferencesApiClient()
